var blockTeamDirectoryHandler = {
    $locationItem = jQuery('.location-item'),
    $employeeHighlightContainer = jQuery('.employee-highlight-container'),
    $tableRow = jQuery('.table-row'),
    $rowEmpty = jQuery('.table-row-empty'),

    setSelectedLocation: function($obj){
        var location = $obj.getAttribute('data-location');
        $selectedEmployeeHighlight = jQuery('.employee-highlight-container[data-location='+location+']');
        $rowSelected = jQuery('.table-row[data-location='+location+']');

        $locationItem.removeClass('active');
        $employeeHighlightContainer.removeClass('active');
        $tableRow.removeClass('active');

        jQuery($obj).addClass('active');
        if ($selectedEmployeeHighlight){
            $selectedEmployeeHighlight.addClass('active');
        }

        if ($rowSelected.length != 0) {
            $rowSelected.addClass('active');
        } else {
            $rowEmpty.addClass('active');
        }
    },

    initialize: function(){
        
		var self = this;

		jQuery("body").on('click', '.location-item', function(){
            self.setSelectedLocation(this);
        })

    }
}

var blockLinksWithYearHandler = {
    initialize: function() {
        $('body').on('change', 'select.year-filter', function() {
            var selectedYear = $(this).val();
            var $parentContainer = $('.block-links-with-year');
            var $linksContainers = $parentContainer.find('.year-links-container').hide();
            $linksContainers.each(function() {
                if ($(this).data('year') == selectedYear) {
                    $(this).show();
                    return false;
                }
            })
        });
        $('select.year-filter').trigger('change');
    }
}

jQuery(document).ready(function($) {

    blockTeamDirectoryHandler.initialize();
    blockLinksWithYearHandler.initialize();
})
